import React from "react";
import { TabButtons } from "./TabButtons";
import routesObj from "../../../routes/RoutesObj";

const SupportTabButtons = () => (
  <TabButtons
    tabs={[
      { title: "All FAQs", to: routesObj.SupportFAQues.path },
    ]}
  />
);

export { SupportTabButtons };
